import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

const AuthField = ({ id, label, error, hint, showPassword, onTogglePassword, ...inputProps }) => (
  <div>
    <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
    <div className="relative">
      <input
        {...inputProps}
        id={id}
        name={inputProps.name || id}
        data-testid={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={[hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(' ') || undefined}
        className={`min-h-[44px] w-full rounded-lg border bg-white px-3 py-2.5 text-base text-gray-900 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-500 disabled:bg-gray-50 ${error ? 'border-red-500' : 'border-gray-300'} ${onTogglePassword ? 'pr-12' : ''}`}
      />
      {onTogglePassword && (
        <button type="button" onClick={onTogglePassword} disabled={inputProps.disabled}
          aria-label={showPassword ? 'Hide password' : 'Show password'} aria-pressed={showPassword}
          className="absolute right-0 top-0 flex h-full w-11 items-center justify-center rounded-lg text-gray-600 hover:text-gray-900">
          {showPassword ? <EyeOff aria-hidden="true" className="h-5 w-5" /> : <Eye aria-hidden="true" className="h-5 w-5" />}
        </button>
      )}
    </div>
    {hint && <p id={`${id}-hint`} className="mt-1.5 text-xs leading-5 text-gray-600">{hint}</p>}
    {error && <p id={`${id}-error`} className="mt-1.5 text-sm text-red-700">{error}</p>}
  </div>
);

export default AuthField;
